import { Link } from "@tanstack/react-router";
import type { Car } from "@/lib/cars";
import { imageDims } from "@/lib/image-dims";
import { Button } from "@/components/ui/button";

export function CarCard({ car, index, booking = false, compact = false }: { car: Car; index?: number; booking?: boolean; compact?: boolean }) {
  const priceLabel = `From $${car.pricePerDay.toLocaleString()} CAD/day`;
  const isAboveFold = typeof index === "number" && index < 2;
  return (
    <article className={`${compact ? "compact-car " : ""}car-card group flex flex-col bg-card border border-border overflow-hidden`}>
      <Link
        to="/fleet/$slug"
        params={{ slug: car.slug }}
        className="relative aspect-[4/3] overflow-hidden bg-black block"
      >
        <img
          src={car.image}
          alt={car.name}
          loading={isAboveFold ? "eager" : "lazy"}
          decoding="async"
          width={imageDims(car.image).width}
          height={imageDims(car.image).height}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
      </Link>
      <div className="p-6 flex flex-col gap-4 flex-1">
        <div>
          <Link to="/fleet/$slug" params={{ slug: car.slug }}>
            <h3 className="font-display text-2xl text-foreground hover:text-foreground/80 transition-colors">{compact ? <><span className="md:hidden">{car.shortName}</span><span className="hidden md:inline">{car.name}</span></> : car.name}</h3>
          </Link>
          <p className="text-xs text-muted-foreground mt-1">{car.tagline}</p>
        </div>
        <div className="mt-auto flex items-center justify-between pt-4 border-t border-border">
          <div className="text-xs text-foreground">{priceLabel}</div>
          <Link
            to="/fleet/$slug"
            params={{ slug: car.slug }}
            className="text-[11px] uppercase tracking-[0.25em] text-foreground border-b border-foreground/40 hover:border-foreground pb-0.5 transition-colors"
          >
            More Info →
          </Link>
        </div>
        {booking && <Button asChild className="md:hidden w-full h-11 rounded-none shadow-none uppercase tracking-widest text-xs"><a href="/book">Book Now</a></Button>}
      </div>
    </article>
  );
}
